import { Injectable } from '@angular/core';

@Injectable()
export class MasterDataUrl {

    public static get GET_DISCOUNT_LIST(): string { return '/api/MasterData/Discount'; }
    public static get GET_DISEASE_DROPDOWN_LIST(): string { return '/api/MasterData/disease/drop-down-list'; }
    public static get GET_ALL_DISEASE(): string { return '/api/MasterData/disease'; }
    public static get GET_OTHER_CENTRES(): string { return '/api/MasterData/otherCentres'; }
    public static get GET_VACCINE_BY_DISEASE(): string { return '/api/MasterData/disease/{id}/vaccine'; }


    public static get GET_DISEASE(): string { return '/api/MasterData/disease/{id}'; }
    public static get ADD_DISEASE(): string { return '/api/MasterData/disease'; }
    public static get UPDATE_DISEASE(): string { return '/api/MasterData/disease/'; }
    public static get REMOVE_DISEASE(): string { return '/api/MasterData/disease/{id}'; }

    public static get GET_ALL_VACCINE(): string { return '/api/MasterData/vaccine'; }
    public static get GET_VACCINE(): string { return '/api/MasterData/vaccine/{id}'; }
    public static get UPDATE_VACCINE(): string { return '/api/MasterData/vaccine/'; }
    public static get REMOVE_VACCINE(): string { return '/api/MasterData/vaccine/{id}'; }

    public static get GET_ALL_SUPPLIER(): string { return '/api/MasterData/supplier'; }
    public static get GET_SUPPLIER(): string { return '/api/MasterData/supplier/{id}'; }
    public static get ADD_SUPPLIER(): string { return '/api/MasterData/supplier'; }
    public static get UPDATE_SUPPLIER(): string { return '/api/MasterData/supplier/'; }
    public static get REMOVE_SUPPLIER(): string { return '/api/MasterData/supplier/{id}'; }

    public static get GET_DEFAULT_COURSE(): string { return '/api/MasterData/defaultCourses'; }
    public static get GET_SITE_TO_ADMINISTER(): string { return '/api/MasterData/siteToAdminister'; }

    public static get GET_ALL_REGION(): string { return '/api/MasterData/region'; }
    public static get GET_ALL_COUNTRY(): string { return '/api/MasterData/country'; }
    public static get GET_DISEASE_VACCINE(): string { return '/api/MasterData/diseasevaccine'; }
    public static get ADD_NEW_DISEASE_VACCINE(): string { return '/api/MasterData/diseasevaccine'; }
    public static get REMOVE_DISEASE_VACCINE(): string { return '/api/MasterData/diseasevaccine/{id}'; }
    public static get UPDATE_DEFAULT_VACCINE(): string {return '/api/MasterData/updatedefaultvaccine/{id}';}

    public static get GET_VAT_CHARGE(): string { return '/api/MasterData/VATCharge'; }

    public static get GET_VACCINE_BY_MEDICALCONDITION(): string { return '/api/MasterData/medicalcontionvaccine'; }
    public static get ADD_MEDICAL_CONDITION_VACCINE(): string { return '/api/MasterData/medicalConditionVaccine'; }
    public static get REMOVE_MEDICAL_CONDITION_VACCINE(): string { return '/api/MasterData/medicalConditionVaccine/{medicalConditionId}/{vaccineId}'; }
    public static get GET_VACCINES(): string { return '/api/MasterData/vaccines'; }


    public static get GET_DISEASE_BY_COUNTRY(): string { return '/api/MasterData/countrydiseases'; }
    public static get GET_ALL_TRIP_CATEGORY(): string { return '/api/MasterData/tripcategory'; }
    public static get ADD_COUNTRY_DISEASE(): string { return '/api/MasterData/countrydiseases'; }
    public static get UPDATE_COUNTRY_DISEASE(): string { return '/api/MasterData/countrydiseases/'; }
    public static get REMOVE_COUNTRY_DISEASE(): string { return '/api/MasterData/countrydiseases/{countryId}/{diseaseId}'; }
    public static get GET_COUNTRY_DISEASE(): string { return '/api/MasterData/countrydiseases/{countryId}/{diseaseId}'; }

    public static get GET_EMAIL_DOMAIN(): string { return '/api/MasterData/emaildomain'; }
    public static get ADD_EMAIL_DOMAIN(): string { return '/api/MasterData/emaildomain'; }
    public static get REMOVE_EMAIL_DOMAIN(): string { return '/api/MasterData/emaildomain/{id}'; }
    public static get GET_EMAIL_DOMAIN_BY_ID(): string { return '/api/MasterData/emaildomain/{id}'; }
    public static get UPDATE_EMAIL_DOMAIN(): string { return '/api/MasterData/emaildomain/'; }

    public static get GET_VACCINE_ADMINISTER_COURSE_NUMBER(): string { return '/api/MasterData/vaccine/{0}/getNoOfAdminister/{1}'; }
    public static get ADD_NEW_VACCINE(): string { return '/api/MasterData/vaccine'; }
    public static get GET_ALL_VACCINE_FOR_ADD_DISEASE(): string { return '/api/MasterData/diseasevaccine/vaccines'; }

    public static get GET_COUNTRIES_DROPDOWNLIST_BY_BASECLINIC(): string { return '/api/MasterData/countryBaseClinicDropdownList'; }
    public static get GET_CENTRES_COUNTRY(): string { return '/api/MasterData/country/{0}/centre'; }

    public static get GET_COUNTRY_REGIONS(): string { return '/api/MasterData/countryRegions'; }

    public static get GET_CENTRE_MANAGEMENT_FEES_BY_CENTREID(): String { return '/api/MasterData/centremanagementfees/{id}'; }
    public static get GET_CENTRE_MANAGEMENT_FEE_BY_ID(): String { return '/api/MasterData/centremanagementfee/{id}'; }
    public static get UPDATE_CENTRE_MANAGEMENT_FEE(): String {return '/api/MasterData/centremanagementfee/{id}' }
    public static get GET_ALL_CENTRE(): string { return '/api/user/centre'}

    public static get GET_MYTMB_MEMO(): string { return '/api/MasterData/mytmb-memo'}

    public static get UPDATE_MYTMB_MEMO(): string { return '/api/MasterData/mytmb-memo'}

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/master-data.urls.ts